import { CoreGraphNode } from "../../../core/graph/CoreGraphNode";
import { NodeEvent } from "../../poly/NodeEvent";
import { CoreType } from "../../../core/Type";
export class NameController {
  constructor(node) {
    this.node = node;
    this._graph_node = new CoreGraphNode(node.scene(), "nodeNameController");
  }
  dispose() {
    this._graph_node.dispose();
    this._on_set_name_hooks = void 0;
    this._on_set_fullPath_hooks = void 0;
  }
  get graph_node() {
    return this._graph_node;
  }
  static baseName(node) {
    let base = node.type();
    const last_char = base[base.length - 1];
    if (!CoreType.isNaN(parseInt(last_char))) {
      base += "_";
    }
    return `${base}1`;
  }
  requestNameToParent(newName) {
    const parent = this.node.parent();
    if (parent && parent.childrenAllowed() && parent.childrenController) {
      parent.childrenController.setChildName(this.node, newName);
    } else {
      console.warn("requestNameToParent failed, no parent found");
    }
  }
  setName(new_name) {
    if (new_name != this.node.name()) {
      this.requestNameToParent(new_name);
    }
  }
  updateNameFromParent(new_name) {
    var _a;
    this.node._setCoreName(new_name);
    this._postSetName();
    this.runPostSetFullPathHooks();
    if (this.node.childrenAllowed()) {
      const children = (_a = this.node.childrenController) == null ? void 0 : _a.children();
      if (children) {
        for (let child_node of children) {
          child_node.nameController.runPostSetFullPathHooks();
        }
      }
    }
    if (this.node.lifecycle.creationCompleted() && this.node.scene().loadingController.loaded()) {
      this.node.scene().missingExpressionReferencesController.checkForMissingNodeReferences(this.node);
      this.node.scene().expressionsController.regenerateReferringExpressions(this.node);
    }
    this.node.scene().referencesController.notifyNameUpdated(this.node);
    this.node.emit(NodeEvent.NAME_UPDATED);
  }
  add_post_set_name_hook(hook) {
    this._on_set_name_hooks = this._on_set_name_hooks || [];
    this._on_set_name_hooks.push(hook);
  }
  add_post_set_fullPath_hook(hook) {
    this._on_set_fullPath_hooks = this._on_set_fullPath_hooks || [];
    this._on_set_fullPath_hooks.push(hook);
  }
  _postSetName() {
    if (this._on_set_name_hooks) {
      for (let hook of this._on_set_name_hooks) {
        hook();
      }
    }
  }
  runPostSetFullPathHooks() {
    if (this._on_set_fullPath_hooks) {
      for (let hook of this._on_set_fullPath_hooks) {
        hook();
      }
    }
  }
}
